import { render, staticRenderFns } from "./asset-tags.vue?vue&type=template&id=537be696&"
import script from "./asset-tags.vue?vue&type=script&lang=js&"
export * from "./asset-tags.vue?vue&type=script&lang=js&"
import style0 from "./asset-tags.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537be696')) {
      api.createRecord('537be696', component.options)
    } else {
      api.reload('537be696', component.options)
    }
    module.hot.accept("./asset-tags.vue?vue&type=template&id=537be696&", function () {
      api.rerender('537be696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/asset-tags/asset-tags.vue"
export default component.exports